import { useStaticSiteConfig } from "@commerce-frontend/ui/providers/StaticSiteConfigProvider";
import { useClientGqlFetcher } from "@labdigital/graphql-fetcher";
import { useQuery } from "@tanstack/react-query";
import { GetSearchResult } from "~/lib/queries/graphql/queries";

export const useSearchResult = (value: string, customerGroupKey?: string) => {
	const config = useStaticSiteConfig();
	const queryKey = ["searchresult", value] as const;
	const gqlClientFetch = useClientGqlFetcher();

	const { data: searchResult, ...rest } = useQuery({
		queryKey,
		queryFn: (a) =>
			gqlClientFetch(GetSearchResult, {
				storeContext: {
					storeKey: config.storeKey,
					currency: config.currency,
					locale: config.locale,
				},
				searchTerm: a.queryKey[1],
				customerGroupKey,
			}).then((r) => r.data?.search ?? undefined),
		enabled: false, // This query can only be triggered using "refetch"
	});

	return {
		searchResult,
		...rest,
	};
};
